/* eslint-disable */
import axios from 'axios'
import store from '@/store'

store.subscribe((mutation) => {
  switch (mutation.type) {
    case 'auth/SET_TOKEN':
      if(mutation.payload) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
        localStorage.setItem('token', mutation.payload)
      }
      else {
        axios.defaults.headers.common['Authorization'] = null
        localStorage.removeItem('token')
      }
      break;

    case 'auth/SET_USER':
      if(mutation.payload) {
        let loggedInUser = Object.assign({}, mutation.payload)
        if(loggedInUser.id) {
          // Safely handle companies array with proper null checks
          let loggedInUserCompanies = loggedInUser && loggedInUser.companies && Array.isArray(loggedInUser.companies)
            ? loggedInUser.companies
            : [];

          let loggedInUserCompaniesId = loggedInUserCompanies.length > 0
            ? loggedInUserCompanies[0].id
            : '';

          console.log(`[SUBSCRIBER] User logged in: ${loggedInUser.email}, role: ${loggedInUser.roles && loggedInUser.roles[0] ? loggedInUser.roles[0].name : 'unknown'}`);
          console.log(`[SUBSCRIBER] User companies: ${loggedInUserCompanies.length} found, setting company-id header to: ${loggedInUserCompaniesId}`);
          axios.defaults.headers.common['company-id'] = loggedInUserCompaniesId;
        }
      }
      else {
        console.log('[SUBSCRIBER] User logged out - clearing headers');
        axios.defaults.headers.common['company-id'] = null;
      }
      break;
  }
})